import { render, staticRenderFns } from "./AppleIcon.vue?vue&type=template&id=1536ed53&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports